<template>
  <div class="search-sem">
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">

        <el-form-item :label="`${$t('sem.condition.obs_from')}:`">
          <el-input size="mini" v-model="searchParams.obs_from"></el-input>
          <!-- <el-date-picker
            size="mini"
            v-model="searchParams.obs_from"
            format="yyyy-MM-ddTHH:mm:ss"
            value-format="yyyy-MM-ddTHH:mm:ss"
            type="datetime">
          </el-date-picker> -->
        </el-form-item>

        <el-form-item :label="`${$t('sem.condition.obs_to')}:`">
          <el-input size="mini" v-model="searchParams.obs_to"></el-input>
          <!-- <el-date-picker
            size="mini"
            v-model="searchParams.obs_to"
            format="yyyy-MM-ddTHH:mm:ss"
            value-format="yyyy-MM-ddTHH:mm:ss"
            type="datetime">
          </el-date-picker> -->
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit">{{$t('sem.condition.search')}}</el-button>
        </el-form-item>

      </el-form>

      <el-table
        :data="dataList"
        style="width: 100%"
        ref="multipleTable"
        @selection-change="handleSelectionChange">
        <el-table-column
          fixed
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="ind"
          label="IND"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="sem_id"
          label="Sem_Id">
        </el-table-column>
        <el-table-column
          prop="date_utc"
          :label="$t('sem.date_utc')">
          <template slot-scope="{row}">
            <span :title="$t('sem.tip.date_utc')">{{row.date_utc}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date_mjd"
          :label="$t('sem.date_mjd')">
          <template slot-scope="{row}">
            <span :title="$t('sem.tip.date_mjd')">{{row.date_mjd}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="hxmt_day"
          :label="$t('sem.hxmt_day')">
        </el-table-column>
        <el-table-column
          prop="start_tt"
          :label="$t('sem.start_tt')">
        </el-table-column>
        <el-table-column
          prop="stop_tt"
          :label="$t('sem.stop_tt')">
        </el-table-column>
        <el-table-column
          prop="duration"
          :label="$t('sem.duration')">
          <template slot-scope="{row}">
            <span :title="$t('sem.tip.duration')">{{row.duration}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('sem.status')">
          <template slot-scope="{row}">
            <span :title="$t('sem.tip.status')">{{row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot="header" >
            <div>
              <el-dropdown @command="handleBulkDownload" v-if="this.userInfo">
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.bulk_down')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'bulkdown'}">
                    {{$t('proposal.bulkwebdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkcopy'}">
                    {{$t('proposal.bulkcopy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkwget'}">
                    {{$t('proposal.bulkget_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.isApply"
              class="op-btn"
              type="text"
              size="small"
              @click="apply(scope.row)">
              {{$t('proposal.apply')}} 
            </el-button>
            <div v-show="scope.row.isDownload">
              <el-dropdown @command="handleDownload">
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.download')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'download', row: scope.row}">
                    {{$t('proposal.webdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'copy', row: scope.row}">
                    {{$t('proposal.copy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'wget', row: scope.row}">
                    {{$t('proposal.get_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <el-dropdown  v-show="scope.row.isDownload" size="small" split-button type="primary" :href="`/download/${scope.row.id}`"> 
              {{$t('proposal.download')}}              
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <el-button
                      v-show="scope.row.isDownload"
                      :data-clipboard-text="`/download/${scope.row.id}`"
                      type="text"
                      size="small">
                      {{$t('proposal.copy_downlink')}}           
                    </el-button>                  
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button
                      v-show="scope.row.isDownload"
                      :data-clipboard-text="scope.row.id"
                      type="text"
                      size="small">
                      {{$t('proposal.get_wget')}}            
                    </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <!-- <el-link v-show="scope.row.isDownload" type="primary" :href="`/download/${scope.row.id}`" target="_blank">{{$t('sem.download')}}</el-link>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button
              v-show="scope.row.isDownload"
              class="copy-btn"
              :data-clipboard-text="`/download/${scope.row.id}`"
              type="text"
              size="small">
              {{$t('sem.copy_downlink')}} 
            </el-button>

            <el-button
              v-show="scope.row.isDownload"
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small">
              {{$t('sem.get_wget')}} 
            </el-button>            -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <NoLoginApplyDialog
        :dialog-visible="noLoginApplyIsVisible"
        :dialog-data="currentDataId"
        :dialog-type="tabletype"
        @ok="confirmNoLoginApplyDialog"
        @close="closeNoLoginApplyDialog">
      </NoLoginApplyDialog>

      <LoginApplyDialog
        :dialog-visible="LoginApplyIsVisible"
        :dialog-data="logincurrentDataId"
        :dialog-type="tabletype"
        @ok="confirmLoginApplyDialog"
        @close="closeLoginApplyDialog">
      </LoginApplyDialog>

      <copyTextDialog
        :dialog-visible="copyTextDialogVisible"
        :dialog-data="copyTextDialogData"
        @close="closeCopyTextDialog">
      </copyTextDialog>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import NoLoginApplyDialog from './NoLoginApplyDialog.vue';
import LoginApplyDialog from './LoginApplyDialog.vue';
import copyTextDialog from './copyTextDialog';

export default {
  name: 'SemSearch',
  components: {
    NoLoginApplyDialog,
    LoginApplyDialog,
    copyTextDialog,
  },
  data() {
    return {
      searchParams: {
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSizes:[10,20, 50, 100, 200,300],
      pageSize: 20,
      total: 0,
      noLoginApplyIsVisible: false,
      currentDataId: null,
      tabletype :'',
      LoginApplyIsVisible:false,
      logincurrentDataId:null,
      copyTextDialogVisible: false,
      copyTextDialogData: '',
      multipleSelection:[],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState([
      'userInfo',
    ]),
    userInfo() {
      return this.$store.state.userInfo;
    },
    dataList() {
      return this.list.map((item) => {
        let isDownload = false;
        let isApply = false;
        let isCopyLink = false;
        let isfile = !!item.file_id;
        if (this.userInfo) {
          isDownload = item.status === 'A' && isfile;
          // console.log('登录用户isDownload',isDownload);
        }else{
          
          isApply = item.status === 'A' && isfile;
          // console.log('未登录用户isapply',isApply);
        }
        return {
          ...item,
          isDownload,
          isApply,
          isCopyLink,
          isfile,          
        }
      });
    },
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/semsearch', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    closeNoLoginApplyDialog() {
      this.noLoginApplyIsVisible = false;
    },
    closeLoginApplyDialog(){
      this.LoginApplyIsVisible = false;
    },
    confirmNoLoginApplyDialog(data) {
      this.closeNoLoginApplyDialog();
      const params = {
        name:data.name,
        id:data.id,
        ogs_id:data.ogs_id,
        remark:data.remark,
        applyemail:data.applyemail,
        applycop:data.applycop,
        data_type:'SEM',
      }
      axios.post('/iapi/apply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }
      });
    },
    confirmLoginApplyDialog(data) {
      this.closeLoginApplyDialog();
      const params = {
        name:data.name,
        id:data.id,
        ogs_id:data.ogs_id,
        applyemail:data.applyemail,
        applycop:data.applycop,
        data_type:'SEM',
      }
      axios.post('/iapi/userapply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }else if (res.data.errcode === 1) {
          alert('请不要重复申请!(Please do not repeat the application!)');
        }
      });
    },
    apply(dataId) {
      this.tabletype = 'SEM';
      if(this.userInfo){
        this.logincurrentDataId = dataId;
        this.LoginApplyIsVisible = true;
      }else{
        this.currentDataId = dataId;
        this.noLoginApplyIsVisible = true;
      }
    },
    handleDownload(data) {
      let urls =  window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/SEM/'+data.row.auth_code;
    
      if (data.type === 'download') {   
          // window.open(urls);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = urls; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
      }

      if (data.type === 'copy') {
        this.copyTextDialogData = urls;
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'wget') {
        this.copyTextDialogData = 'wget ' +urls;
        this.copyTextDialogVisible = true;
      }
    },
    handleBulkDownload(data){
      if(this.multipleSelection){
        this.multipleSelection.forEach(row =>{
          if(!row.isDownload){
            this.$refs.multipleTable.toggleRowSelection(row,false);
          }
        })
      }
      if(this.multipleSelection.length===0){
        alert('请选择数据!')
        return;
      }
      let urls = [];
      
      this.multipleSelection.forEach((dataitem)=>{
        let childurl = window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/SEM/'+dataitem.auth_code;
        urls = urls.concat(childurl);

      });

      if (data.type === 'bulkdown') {
        urls.forEach((item) => {
          // console.log('下载地址',item);
          // window.open(item);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = item; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
        });
      }
      if (data.type === 'bulkcopy') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'bulkwget') {
        this.copyTextDialogData = urls.map((item) => {
          return 'wget ' + item;
        }).join('\r\n');
        this.copyTextDialogVisible = true;
      }
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    closeCopyTextDialog() {
      this.copyTextDialogVisible = false;
    },
  },
};
</script>

<style scoped>
.search-sem {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 22px;
}
</style>
